import { RootState } from '../../../base';
import { createSelector } from '@reduxjs/toolkit';

const getCompanyBaseUsers = (state: RootState) => state.user.companyBaseUsers;

const selectUsersOptions = createSelector([getCompanyBaseUsers], (users) => {
    return users.map((user) => ({
        label: `${user.firstName} ${user.lastName}`,
        value: String(user.id),
        key: String(user.id),
        iconUrl: user.profilePicture,
    }));
});

export const userSelectors = {
    getMyUser: (state: RootState) => state.user.myUser,
    getIsMyUserLoading: (state: RootState) =>
        state.user.uiState.isMyUserLoading,
    getCompanyBaseUsers,
    getUsersOptions: selectUsersOptions,
    getCompanyInfo: (state: RootState) => state.user.myUser?.company,
    getPageDirection: (state: RootState) => state.user.uiState.pageDiraction,
    getUserMailboxes: (state: RootState) =>
        state.user.myUser?.userMailboxes || [],
};
